export enum Gender {
  MALE = 'MALE',

  FEMALE = 'FEMALE',

  NON_BYNARY = 'NON_BYNARY',

  LGBTIQ = 'LGBTIQ',

  OTHERS = 'OTHERS',
}
